import React from 'react';
import PropTypes from 'prop-types';
import './_alert.scss';
import classnames from 'classnames';

class Alert extends React.Component {
    static propTypes = {
      children: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
      size: PropTypes.oneOf(['sm', 'md', 'lg']),
      severity: PropTypes.oneOf(['success', 'info', 'danger', 'warning']),
      className: PropTypes.any,
    }

    static defaultProps = {
      size: 'md',
    };

    get classNames() {
      const { className, size, severity } = this.props;
      return classnames('alert', {
        [className]: className,
        'alert-sm': size === 'sm',
        'alert-md': size === 'md',
        'alert-lg': size === 'lg',
        'alert-success': severity === 'success',
        'alert-info': severity === 'info',
        'alert-danger': severity === 'danger',
        'alert-warning': severity === 'warning',
      });
    }

    render() {
      return (
        <div className={this.classNames}>{this.props.children}</div>
      );
    }
}

export default Alert;
